export class Lead {
	constructor() {
		//this.yaCounter = yaCounter52696993;
		//sbjs.init();
	}

	sendZayav(parent) {
		this.send(parent, 24, "lid")
		return false
	}

	sendOrder(parent) {
		this.send(parent, 9, "order")
		return false
	}

	send(parent, mid, leadName) {
		this.yaCounter = yaCounter64652308;
		
		$(document).css("cursor", "wait")
		var el = $(parent)
		el.addClass("loader")

		var submit = el.find("input[type='submit']")
		console.log(el.serialize())

		//let src = sbjs.get.current.src + '/' + 	sbjs.get.current.mdm;
		let _y = this.yaCounter

		$.ajax({
			url: "/ajax.php?mid=" + mid,
			type: "POST",
			data: el.serialize() + "&str_page=" + document.title + "&mode=send_request",
			dataType: "json",
			beforeSend: function() {
				submit.prop("disabled", true)
			},
			success: function(res) {
				if (res["success"] == 1) {
					//ga('send', 'event', 'lid', leadName, res['id']);
					_y.reachGoal('lid');

					// submit.prop("disabled", true)

					// el.html(
					// 	'<div class="success">Спасибо за Вашу заявку. Мы свяжемся с Вами в ближайшее время!</div>'
					// )

					// $(document).css("cursor", "auto")

					var html = "<p>Для оплаты вашего заказа пройдите по <a href='/pay/?inv_id="+res["payment_id"];
					html += "&item_id="+ res['id']+"'>ссылке</a>";
					
					if (res.html)
						html = res.html;

					el.replaceWith(html);

					el.removeClass("loader")

					//закрыть модальное окно по клику на крестик
					$('.popup__close').on('click', function(){
						$(this).parents('.popup').removeClass('active');
						$('body').removeClass('no-scroll');
					});


				} else {
					alert(
						"Ошибка: " +
							res["error"] +
							". Пожалуйста, повторите попытку или свяжитесь с нами. Приносим извинения за неудобства."
					)
					$(document).css("cursor", "auto")
					el.removeClass("loader")
				}
			},
			error: function(e) {
				console.log(e)
			},
		})
	}
}
